/* eslint-disable no-console */
import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log("Conteúdo em cache (service worker ativo).");
    },
    registered() {
      console.log("Service worker registrado.");
    },
    cached() {
      console.log("Conteúdo disponível offline.");
    },
    updatefound() {
      console.log("Nova versão a descarregar.");
    },
    updated() {
      console.log("Nova versão disponível; atualize a página.");
    },
    offline() {
      console.log("Sem ligação à rede; modo offline se aplicável.");
    },
    error(error) {
      console.error("Erro ao registar o service worker:", error);
    },
  });
}
